import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '@carbon/react';
import { Renew } from '@carbon/icons-react';
import { kiemBan } from './banCms';

// Mot loi khi ve khong duoc lam trang ca CMS (React go ca cay khi khong co ranh gioi loi): menu, thanh tren
// va phan con lai cua trang van con, cho loi hien thong bao va nut tai lai. Tab chay ban cu (vua deploy)
// thi tu tai lai (banCms). `khoa` doi (duong dan, nguoi choi) thi ranh gioi mo lai.
export class LoiTrang extends Component<{ khoa: string; muc?: boolean; children: ReactNode }, { loi: Error | null }> {
  state: { loi: Error | null } = { loi: null };

  static getDerivedStateFromError(loi: unknown) {
    return { loi: loi instanceof Error ? loi : new Error(String(loi)) };
  }

  componentDidCatch(loi: Error, info: ErrorInfo) {
    console.error('CMS: loi khi ve', loi, info.componentStack);
    void kiemBan();
  }

  componentDidUpdate(prev: { khoa: string }) {
    if (prev.khoa !== this.props.khoa && this.state.loi) this.setState({ loi: null });
  }

  render() {
    if (!this.state.loi) return this.props.children;
    const box = (
      <div className="state" role="alert">
        <h3>{this.props.muc ? 'Mục này gặp lỗi khi hiển thị' : 'Trang gặp lỗi khi hiển thị'}</h3>
        <p>{this.state.loi.message}</p>
        <p className="muted">Tải lại trang để lấy bản CMS mới nhất.{this.props.muc ? ' Phần còn lại của trang vẫn dùng được.' : ' Các trang khác trong menu vẫn dùng được.'}</p>
        <Button kind="tertiary" size="sm" renderIcon={Renew} onClick={() => location.reload()}>Tải lại trang</Button>
      </div>
    );
    return this.props.muc ? box : <div className="page">{box}</div>;
  }
}
